import React, { useEffect, useState } from 'react';
import { Steps } from 'antd';
import styled from 'styled-components';
import {
  boxShadow,
  greyColor, maxMobile, maxTablet, maxWidth,
  primaryColor, primaryFont, retina, secondaryFont, wMLight, wMedium,
} from 'Utils/utilsStyle';
import { useDispatch, useSelector } from 'react-redux';
import { actions as UiAction } from 'Slice/UISlice';
import { actions as flurryActions } from 'Slice/HelperSlice';
import { actions } from 'Slice/ProfileConfirmationSlice';
import { selectFollowedCompanies, selectPersonId } from 'Selector/OnboardingSelector';
import { peopleData, selectCompaniesFollowedSearchResults } from 'Selector/GlobalSearchResultsSelector';
import { selectCompanyCount } from 'Selector/CompaniesSelector'
import { getCurrentTime, setLocalStorageValue, valueToObject } from 'Utils/UtilityFunctions';
import { useNavigate } from 'react-router-dom';
import { selectSearchedPeople } from 'Selector/ProfileConfirmationSelector';
import { Company } from 'Types/CompaniesTypes';
import classNames from 'classnames';
import { actions as OnboardinnActions } from '../../Slice/OnboardingSlice';

const Wrapper = styled.div`
  position: absolute;
  bottom: 0px;
  width: 100%;
  background: #FFF;
  box-shadow: ${boxShadow};
  display: flex;
  align-items: center;
  .ant-steps .ant-steps-item:not(.ant-steps-item-active)>.ant-steps-item-container[role=button]:hover .ant-steps-item-title {
    color: ${primaryColor};
  }
  .ant-steps-item-wait .ant-steps-item-icon>.ant-steps-icon .ant-steps-icon-dot {
    background: #7e7e7e;
}
  .ant-steps {
    &.disableContinue {
      .ant-steps-item {
        &:last-child {
          .ant-steps-item-container {
            .ant-steps-item-content {
              pointer-events: none;
              cursor: not-allowed;
              opacity: 0.4;
            }
          }
        }   
      }
    }
    height: 79px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      height: 66px;
    }
    @media all and (max-width: ${maxTablet}) {
      height: 53px;
    }
    @media all and (max-width: ${maxMobile}) {
      flex-direction: row !important;
      height: 69px;
    }
    .ant-steps-item {
      @media all and (max-width: ${maxTablet}) {
        flex: 1 1 20% !important;
      }
      &.disabledStep {
          pointer-events: none;
        }
      &:nth-child(1) {
      .ant-steps-item-container {
          .ant-steps-item-icon {
            .ant-steps-icon {
              .ant-steps-icon-dot {
                left: 0px;
                &::after {
                  content: "1";
                }
              }
            }
          }
        }
      }
      &:nth-child(2) {
      .ant-steps-item-container { 
          .ant-steps-item-icon {
            .ant-steps-icon {
              .ant-steps-icon-dot {
                &::after {
                  content: "2";
                }
              }
            }
          }
        }
      }
      &:nth-child(3) {
      .ant-steps-item-container {
          .ant-steps-item-icon {
            .ant-steps-icon {
              .ant-steps-icon-dot {
                &::after {
                  content: "3";
                }
              }
            }
          }
        }
      }
      &:nth-child(4) {
      .ant-steps-item-container {
          .ant-steps-item-icon {
            .ant-steps-icon {
              .ant-steps-icon-dot {
                &::after {
                  content: "4";
                }
              }
            }
          }
        }
      }
      &:last-child {
        flex: 1 1;
        .ant-steps-item-container {
          &:hover {
            .ant-steps-item-title {
              color: #fff !important;
            }
          }
          .ant-steps-item-tail {
            display: block;
          }
          .ant-steps-item-icon {
            display: none;
          }
          .ant-steps-item-content {
            display: flex;
            align-items: center;
            justify-content: center;
            background: ${primaryColor};
            border-radius: 10px;
            padding: 14px 68px;
            height: 48px;
            min-width: 205px;
            cursor: pointer;
            @media all and (max-width: ${maxWidth}), ${retina} {
              width: 157px;
              min-width: 157px;
              height: 36px;
            }
            @media all and (max-width: ${maxTablet}) {
              width: 117px;
              min-width: 117px;
              padding: 12px 40px;
              height: 26px;
              border-radius: 6px;
            }
            @media all and (max-width: ${maxMobile}) {
              margin-right: 20px;
            }
            .ant-steps-item-title {
              color: #FFF !important;
              text-align: center;
              font-family: ${primaryFont};
              font-size: 18px;
              font-weight: ${wMLight};
              @media all and (max-width: ${maxWidth}), ${retina} {
                font-size: 16px;
              }
              @media all and (max-width: ${maxTablet}) {
                font-size: 14px;
              }
            }
          }
        }
      }
      &.ant-steps-item-active {
        .ant-steps-item-container {
          .ant-steps-item-icon {
            top: 0px;
          }
          .ant-steps-item-content {
            .ant-steps-item-title {
              color: ${primaryColor};
            }
          }
        }
      }
      &.ant-steps-item-finish {
        .ant-steps-item-container {
        .ant-steps-item-tail {
          &::after {
            background-color:  ${primaryColor};
          }
        }
        .ant-steps-item-icon {
          .ant-steps-icon {
            color: ${primaryColor};
            .ant-steps-icon-dot {
              background: ${primaryColor};
            }
          }
        }
        .ant-steps-item-content {
          .ant-steps-item-title {
            color: ${primaryColor};
          }
        }
      }
    }
      &.ant-steps-item-process {
        .ant-steps-item-container {
        .ant-steps-item-tail {
          &::after {
            background-color:  ${primaryColor};
          }
        }
        .ant-steps-item-icon {
          .ant-steps-icon {
            color: ${primaryColor};
            .ant-steps-icon-dot {
              background: ${primaryColor};
            }
          }
        }
      }
    }
      .ant-steps-item-container {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor:pointer;
        .ant-steps-item-tail {
          top: -6px;
          margin: 0 0 0 0;
          @media all and (max-width: ${maxTablet}) {
            top: -4px;
          }
          @media all and (max-width: ${maxMobile}) {
            top: -3px;
          }
          &::after {
            width: calc(100% + 0px);
            background-color:  #E6E6E6;
            margin-left: 0px;
            height: 6px;
            border-radius: 0px;
            @media all and (max-width: ${maxTablet}) {
              height: 4px;
            }
            @media all and (max-width: ${maxMobile}) {
              height: 5px;
            }
          }
        }
        .ant-steps-item-icon {
          width: 21px;
          height: 21px;
          margin-left: 0px;
          @media all and (max-width: ${maxWidth}), ${retina} {
            width: 20px;
            height: 20px;
          }
          @media all and (max-width: ${maxTablet}) {
            width: 16px;
            height: 16px;
          }
          @media all and (max-width: ${maxMobile}) {
            margin-right: 0px;
          }
          .ant-steps-icon {
            height: inherit;
            width: inherit;
            display: flex;
            @media all and (max-width: ${maxTablet}) {
              line-height: unset;
            }
            .ant-steps-icon-dot {
              &::after {
                width: 21px;
                height: 21px;
                @media all and (max-width: ${maxWidth}), ${retina} {
                  width: 20px;
                  height: 20px;
                }
                top: 0px;
                left: 0px;
                color: #fff;
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                @media all and (max-width: ${maxTablet}) {
                  width: 16px;
                  height: 16px;
                  font-size: 9px;
                  top: 0px;
                }
              }
            }
          }
        }
        .ant-steps-item-content {
          display: inline-block;
          margin-top: 0px;
          width: unset;
          @media all and (max-width: ${maxMobile}) {
            display: none;
          }
          .ant-steps-item-title {
            color: ${greyColor};
            text-align: center;
            font-family: ${secondaryFont};
            font-size: 20px;
            font-weight: ${wMedium};
            letter-spacing: -0.5px;
            @media all and (max-width: ${maxWidth}), ${retina} {
              font-size: 18px;
            }
            @media all and (max-width: ${maxTablet}) {
              font-size: 12px;
            }
            &::after {
              display: none;
            }
          }
        }
      }
    }
  }
`;

type Props = {
  activeIndex: number
};

const OnboardingFooter = function OnboardingFooter(props: Props) {
  const { activeIndex } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { Step } = Steps;
  const [current, setCurrent] = React.useState(0);

  const followedCompanies = useSelector(selectFollowedCompanies);
  const followedCompaniesFromSearch = useSelector(selectCompaniesFollowedSearchResults);
  const followedCompaniesCount = useSelector(selectCompanyCount);
  const personId = useSelector(selectPersonId);
  const peopleSection = useSelector(peopleData);
  const searchedPeople = useSelector(selectSearchedPeople);
  const host = window.location.href;
  const startTime = getCurrentTime();
  const { persons } = peopleSection;

  const [visitedSteps, setVisitedSteps] = useState<number[]>([0]);
  const [companyIds, setCompanyIds] = useState<string>('');

  const isStep3Incomplete = followedCompaniesCount < 3;

  const getRecommendedPeople = (ids: string) => {
    dispatch(OnboardinnActions.getRecommendedPeopleOnboarding({
      entity_id: personId,
      companyId: ids,
    }));
  };

  useEffect(() => {
    if (companyIds.length > 0) {
      getRecommendedPeople(companyIds);
    }
  }, [companyIds]);

  const getUniqueCompanyIds = (
    arr1: Company[],
    arr2: Company[],
  ) => {
    const ids1 = arr1.map((company) => company.companyId.toString());
    const ids2 = arr2.map((company) => company.companyId.toString());

    const combinedIds = [...ids1, ...ids2];
    const uniqueIds = Array.from(new Set(combinedIds));

    return {
      uniqueIds: uniqueIds.join(', '),
      length: uniqueIds.length,
    };
  };

  const isContinueDisabled = () => {
    return isStep3Incomplete;
  };

  const stepTitles = [
    {
      title: 'Get Started',
    },
    {
      title: 'Confirm Profile',
    },
    {
      title: 'Follow Company',
    },
    {
      title: 'Follow People',
    },
    {
      title: current === 4 ? 'Finish' : 'Continue',
    },
  ];

  const finished = () => {
    setLocalStorageValue('skipOnBoarding', '1');
    navigate('/');
  };

  const continueMapping = () => {
    if (persons) {
      dispatch(actions.setConfirmedPerson(searchedPeople?.[activeIndex]));
    }
    dispatch(flurryActions.callFlurryEvent(
      valueToObject('profile_mapping_complete', 0, { id: searchedPeople?.[activeIndex] }),
    ));
  };

  const handleClick = (idx: number) => {
    const diff = Math.abs(idx - current);
    if (idx === 0) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('click_Navigation_GettingStartedBottom_Onboarding', startTime, {
          host,
        }),
      ));
    }
    if (idx === 1) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('click_Navigation_ConfirmProfileBottom_Onboarding', startTime, {
          host,
        }),
      ));
    }
    if (idx === 2) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('click_Navigation_FollowCompanyBottom_Onboarding', startTime, {
          host,
        }),
      ));
    }
    if (idx === 3 && !isStep3Incomplete) {
      dispatch(flurryActions.callFlurryEvent(
        valueToObject('click_Navigation_FollowPeopleBottom_Onboarding', startTime, {
          host,
        }),
      ));
    }
    if ((idx === 3 && isContinueDisabled())) return;
    if (idx === 4) {
      if (current === 0) {
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('click_Continue_GettingStarted_Onboarding', startTime, {
            host,
          }),
        ));
      }
      if (current === 1) {
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('click_Continue_ConfirmProfile_Onboarding', startTime, {
            host,
          }),
        ));
      }
      if (current === 2 && !isContinueDisabled()) {
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('click_Continue_FollowCompany_Onboarding ', startTime, {
            host,
          }),
        ));
      }
      if (current === 3) {
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('click_Continue_FollowPeople_Onboarding', startTime, {
            host,
          }),
        ));
      }

      if (current === 4) {
        dispatch(flurryActions.callFlurryEvent(
          valueToObject('click_Finish_Onboarding_Onboarding', startTime, {
            host,
          }),
        ));
      }

      if (current === 2 && isContinueDisabled()) {
        dispatch(flurryActions.setNotification({
          message: 'Follow at least 3 companies to proceed forward',
          proTip: false,
          rightPlacement: false,
          groupId: 0,
          classnameFlag: false,
        }));
        return;
      }
      setCurrent((prevIdx) => prevIdx + 1);
    } else if (diff > 1) {
      if (!visitedSteps.includes(idx)) return;
      setCurrent(idx);
    } else {
      setCurrent(idx);
    }
    setVisitedSteps((prev) => {
      if (!prev.includes(idx)) {
        return [...prev, idx];
      }
      return prev;
    });
  };

  useEffect(() => {
    if (current === 5) {
      continueMapping();
      finished();
    } else if (current === 3) {
      const { uniqueIds } = getUniqueCompanyIds(
        followedCompanies || [],
        followedCompaniesFromSearch || [],
      );

      setCompanyIds(uniqueIds);
    }
    dispatch(UiAction.setOnBoardingSlide(current));
  }, [current]);

  return (
    <Wrapper id="onboarding-revamp-footer-id">
      <Steps
        current={current}
        progressDot
        responsive={false}
        className={classNames({ disableContinue: isContinueDisabled() && current === 2 })}
      >
        {stepTitles.map((t, index: number) => (
          <Step
            title={t.title}
            data-index={index + 1}
            onClick={() => handleClick(index)}
            className={classNames({ disabledStep: isStep3Incomplete && index === 3 })}
          />
        ))}
      </Steps>
    </Wrapper>
  );
};

export default OnboardingFooter;
